import { theme } from "themes/default/theme"

export const styles = {
  gameSelectDialog: {
    ...theme.mixins.modalContent,
    overflow: "visible",
    p: 0,
    m: 0,
    minHeight: 0,
    maxWidth: 800,
  },
  mainImage: {
    width: "75px!important",
    height: "75px!important",
    position: "absolute",
    zIndex: 1,
    top: -35,
    left: "50%",
    transform: "translateX(-50%)",
  },
  item: (theme) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: 2.5,
    padding: 0.625,
  }),
  star: (theme) => ({
    color: theme.palette.common.black,
  }),
  starSelected: {
    color: `#ffb400`,
  },
  hoverButton: (theme) => ({
    p: 0,
    "& .icon": {
      display: "flex!important",
    },
    "& .active-icon": {
      display: "none!important",
    },
    "&:hover .active-icon": {
      display: "flex!important",
    },
    "&:hover .icon": {
      display: "none!important",
    },
    "&:hover span": {
      color: theme.palette.common.black,
    },
  }),
  gameItem: {
    px: 2,
    py: 1,

    // cursor: "pointer",
    // border: `1px solid ${theme.palette.common.black}`,
    // p: 1,
    // borderRadius: 2,
    // backgroundColor: theme.palette.common.white,
    // color: theme.palette.common.black,
    // "&:hover": {
    //   backgroundColor: theme.palette.primary.main,
    //   borderColor: theme.palette.primary.main,
    //   color: theme.palette.common.white,
    // },
  },
  gameItemDisabled: (theme) => ({
    cursor: "not-allowed",
    border: `1px solid ${theme.palette.grey[500]}`,
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.common.black,
    "&:hover": {
      backgroundColor: theme.palette.grey[500],
      borderColor: theme.palette.grey[500],
      color: theme.palette.common.black,
    },
  }),
}
